import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchSeverityRules = (customer) => {
  return axios({
    url: `/rule/${customer}/list`,
    method: 'get'
  });
};

const useGetSeverityRules = (customer) => {
  return useQuery(['severity_rules', customer], () => fetchSeverityRules(customer), {
    enabled: !!customer
  });
};

export default useGetSeverityRules;
